import styles from '../timeline.module.css';

const PostVideo = (props) => {
	return (
		<>
			<video controls preload='auto' id='my-video' className={styles.postVideo}>
				<source src={props.post?.videos[0]?.url} />
			</video>
		</>
	);
};

export default PostVideo;
